import styled from 'styled-components';

export const FiltrarCursoContainer = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    background-color: white;
    margin-bottom: 5px;
    box-sizing: border-box;

    @media only screen and (max-width: 912px) {
        min-height: auto;
        justify-content: space-between;
        flex-wrap: nowrap;
        gap: 20px;
        padding: 0;
        border: none;
        border-radius: 0;
        margin-bottom: 36px;
    }
`;

export const FilterLeftGroup = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 32px;

    @media only screen and (max-width: 912px) {
        width: auto;
        flex-wrap: nowrap;
        gap: 28px;
    }
`;

export const FiltroContainer = styled.div<{ $disabled?: boolean }>`
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    min-width: 110px;
    width: auto;
    height: 40px;

    border: 1px solid #003c78;
    border-radius: 8px;
    padding: 8px 12px;
    gap: 8px;
    cursor: ${props => (props.$disabled ? 'not-allowed' : 'pointer')};
    opacity: ${props => (props.$disabled ? 0.5 : 1)};
    transition: background-color 0.2s ease;
    box-sizing: border-box;

    &:hover {
        background-color: #f0f5fa;
    }

    @media only screen and (max-width: 912px) {
        min-width: 110px;
        width: auto;
        height: 40px;
        padding: 8px 12px;
        gap: 8px;
    }
`;

export const DropdownWrapper = styled.div`
    position: relative;
`;

export const DropdownMenu = styled.div`
    position: absolute;
    top: calc(100% + 8px);
    left: 0;
    min-width: 220px;
    background-color: #ffffff;
    border: 1px solid #003c78;
    border-radius: 8px;
    padding: 8px 0;
    box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.12);
    z-index: 100;
`;

export const DropdownOption = styled.button`
    display: block;
    width: 100%;
    padding: 12px 16px;
    border: none;
    background-color: #ffffff;
    color: #003c78;
    font-family: 'Barlow';
    font-size: 14px;
    line-height: 18px;
    text-align: left;
    cursor: pointer;

    &:hover {
        background-color: #f0f5fa;
    }
`;

export const ActiveDropdownOption = styled(DropdownOption)`
    font-weight: 600;
    background-color: #f0f5fa;
`;

export const OrdenarContainer = styled(FiltroContainer)`
    width: 126px;

    @media only screen and (max-width: 912px) {
        width: 126px;
        height: 40px;
        margin-left: 0;
        padding: 8px 12px;
        border-radius: 8px;
    }
`;

export const Span = styled.span`
    font-family: 'Barlow';
    font-weight: 400;
    font-size: 14px;
    line-height: 16px;
    letter-spacing: 0;
    text-align: center;
    color: #003c78;
    white-space: nowrap;

    @media only screen and (max-width: 912px) {
        font-size: 12px;
        line-height: 14px;
    }
`;

export const DropdownMenuRight = styled.div`
    position: absolute;
    top: calc(100% + 8px);
    right: 0;
    min-width: 220px;
    background-color: #ffffff;
    border: 1px solid #003c78;
    border-radius: 8px;
    padding: 8px 0;
    box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.12);
    z-index: 100;
`;